import { Component, ElementRef, ViewChild, OnInit, Input, Output, EventEmitter, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { SearchService } from '.././services/search.service';
import { forEach, uniqBy } from 'lodash';

@Component({
  selector: 'property-search',
  templateUrl: './property-search.component.html',
  styleUrls: ['./property-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PropertySearchComponent implements OnInit, OnDestroy {
  @Input() propSearchInput = new Subject<string>();
  @Output() onPropertySelected: EventEmitter<any> = new EventEmitter<any>();
  private searchStr: string;
  propertiesList: Observable<Array<any>>;

  @Output() showSuggestions: EventEmitter<boolean> = new EventEmitter<boolean>();
  private subscriptions: any[] = [];
  inProgress: boolean = true;

  constructor(private searchService: SearchService) { }

  ngOnInit() {
    this.propertiesList = this.propSearchInput.debounceTime(400)
      .map(s => this.searchStr = s)
      .switchMap(s => {
        if (s) {
          this.inProgress = true;
          return this.searchService.getProperties(s)
        } else {
          return Observable.of({ rows: [] })
        }
      })
      .map(props => {
        let properties: Array<any> = props.rows;
        let term: string = this.searchStr;
        this.inProgress = false;
        return properties.filter(function(p) {
          return (p.PropertyName.toString().toLocaleLowerCase().includes(term.toLocaleLowerCase()) ||
            (p.FullAddress && p.FullAddress.toString().toLocaleLowerCase().includes(term.toLocaleLowerCase())) ||
            p.ZIP.toString().includes(term));
        })
      })
      .do(() => this.showSuggestions.emit(true));
  }

  ngOnDestroy() {
    forEach(this.subscriptions, (s) => s.unsubscribe());
    this.subscriptions = [];
    this.onPropertySelected.complete();
  }

  propertySelected(property: any) {
    if (!!property) {
      let prop: any = {
        searchType: 'property',
        id: +property.PropertyId,
        propertyName: property.PropertyName,
        latitude: property.Latitude,
        longitude: property.Longitude,
        city: property.City,
        state: property.STATE,
        zipCode: property.ZIP,
        imageHero: property.ImageHero,
        propertyId: +property.PropertyId,
        address: property.FullAddress,
        marketId: +property.MPFMKT,
        heroSource: 'RealPage',
        type: property.MPFSiteType
      };
      this.onPropertySelected.emit({ property: prop, showMarker: true });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/search/property-search/property-search.component.ts